import React from "react";
import classNames from "classnames";
import usePageFiltersOpenState from "../../../hooks/usePageFiltersOpenState";
import filtersActiveIcon from "../../../resources/images/icons/filters-active.svg";
import filtersInactiveIcon from "../../../resources/images/icons/filters-inactive.svg";

export default function ToggleFiltersButton() {
    const {isOpen, togglePersistedOpen} = usePageFiltersOpenState();
    const buttonClassName = classNames("filters-btn", {active: isOpen});
    const iconSrc = isOpen ? filtersActiveIcon : filtersInactiveIcon;

    return (
        <div
            className={buttonClassName}
            onClick={togglePersistedOpen}
            title="Фильтры"
        >
            <img src={iconSrc} alt="" width="50" height="50" />
        </div>
    );
}
